import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({ standalone:false,
  selector: 'app-activate-adoption-dialog',
  templateUrl: './activate-adoption-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./activate-adoption-dialog.component.scss']
})
export class ActivateAdoptionDialogComponent {
  title: string = "Deactivate this moov?"
  cancelButtonText = "CANCEL";
  deactivateButtonText = "DEACTIVATE";
  activateButtonText = "REACTIVATE";
  public submitButtonText:string;
  public isActive:boolean;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<ActivateAdoptionDialogComponent>) {
    this.submitButtonText=this.data.isActive?this.deactivateButtonText:this.activateButtonText;
    this.isActive = data.isActive;
  }

  onSubmitClick(): void {
    this.dialogRef.close(true);
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

}

